import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { Tooltip } from '@/js/model'
import apiClient from '@/js/api/api-client'
import { useLoading } from '@/js/utils/useLoading'

export const useTooltipStore = defineStore('tooltip', () => {
    const { isLoading, isMethodLoading, loadingMethods, setLoading, errors } = useLoading()
    const tooltips = ref<Array<Tooltip>>([])

    const replaceTooltipInState = (newTooltip: Tooltip) => {
        const index = tooltips.value.findIndex((tooltip) => tooltip.id === newTooltip.id)
        tooltips.value.splice(index, 1, newTooltip)
    }
    async function fetchTooltips(): Promise<void> {
        await setLoading('fetchTooltips', async () => {
            const url = '/api/tooltips'
            const result = await apiClient.get(url, {
                params: {
                    pagination: false
                }
            })
            tooltips.value = result.data['hydra:member']
        })
    }

    async function updateTooltip(tooltip: Tooltip) {
        await setLoading('updateTooltip', async () => {
            const url = `/api/tooltips/${tooltip['id']}`
            const result = await apiClient.put(url, tooltip)
            replaceTooltipInState(result.data)
        })
    }

    const getTooltipForField = computed(() => {
        return (fieldName: string) =>
            tooltips.value.find((tooltip: Tooltip) => tooltip.modulFeld === fieldName)
    })

    return {
        tooltips: tooltips,
        errors,
        isLoading,
        fetchTooltips,
        updateTooltip,
        getTooltipForField
    }
})
